import { TextField } from "@mui/material";
import { useCallback } from "react";

export type TruxSimpleSelectFieldProps<T> = {
  value: T,
  onChange: (t: any) => boolean | void,
  children: React.ReactNode,
  disabled?: boolean
}

export default function TruxSimpleSelectField<T>({ value, onChange, children, disabled=false }: TruxSimpleSelectFieldProps<T>) {
  const fieldOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const val = e.target.value as any;

    onChange(val);
  }, [onChange]);

  return <TextField label="" size="small" sx={{ display: "flex", width: "100%" }} value={value} onChange={fieldOnChange} select disabled={disabled}>
    {children}
  </TextField>
}